import _axios from '@/util/httpConfig.js'

// 获取公告详情
export const getInfo = (contentCode, type="contentNews") => {
  return _axios('GET', `/common-content/${type}/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
} 


// WEBPACK FOOTER //
// ./src/api/common.js